import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HistOrder } from 'src/app/hist/models/hist-order';
import { HistPrintOperationDataDto, HistPrintOperationDataItemDto, HistPrintOriginalDataDto } from 'src/app/hist/models/hist-print-operation-data';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { HcrService } from 'src/app/services/hcr-service.service';
import { LocalPrintService } from 'src/app/services/local-print.service';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { CidMaskPipe } from 'src/app/shared/pipes/cid-mask.pipe';
import { PageUnit, ReportPagePaginator } from '../report-page-paginator';

@Component({
  selector: 'app-report-hist-print-original',
  templateUrl: './report-hist-print-original.component.html',
  styleUrls: ['./report-hist-print-original.component.css'],
  providers: [CidMaskPipe]
})
export class ReportHistPrintOriginalComponent implements OnInit {

  @Input()
  numberOfCopies: number = 1;

  @Input()
  set singleData(value: HistPrintOriginalDataDto) {
    if (value) {
      this.fillData([value], false, false);
    }
  }

  @Input()
  set multipleData(value: HistPrintOriginalDataDto[]) {
      if (value && value.length > 0) {
        this.fillData(value, false, false);
      }
    }

  @Input()
  set setICodes(value: ValueTextPair[]) {
    if (value) {
      this.icodes = value;
    }
  }

  @Input()
  set setCidMask(value: string) {
    if (value) {
      this.cidMask = value;
    }
  }

  @Input()
  printSecondName: boolean = true;

  @Output()
  printed = new EventEmitter<boolean>();

  sizePage = {
    width: 20, //cm
    height: 29.4 //cm
  };
  paddingPage = {
    top: 0, //cm
    right: 0, //cm
    bottom: 0.3, //cm
    left: 0 //cm
  };

  heightPageWithoutPadding = this.convertCmtoPx(
    this.sizePage.height - (this.paddingPage.top + this.paddingPage.bottom)
  );
  elContainer: any;
  pageContent = [[]];

  @ViewChild('reportContainer', { static: false })
  reportContainer: ElementRef<HTMLDivElement>;

  commonStyle = 'border-right: 0px solid black;  border-left: 0px solid black; border-bottom: 0px solid black; border-top: 0px solid black; vertical-align: middle;';
  commonStyle1 = 'border-right: 0px solid black;  border-left: 0px solid black; border-bottom: 1px solid black; border-top: 0px solid black; vertical-align: middle;';
  commonStyle2 = 'border-right: 0px solid black;  border-left: 0px solid black; border-bottom: 0px solid black; border-top: 1px solid black; vertical-align: middle;';
  commonClass = '';
  commonClassText = '';
  upperboundIndex: number = 0;
  nowStr: string = '';
  timeStr: string = '';
  totalRecord: number = 0;
  pageNo: number = 1;
  reportData: HistPrintOriginalDataDto[];
  reportName: string = '';
  shortReportName: string = '';
  forExcel: boolean = false;
  icodes: ValueTextPair[] = [];
  cidMask: string = '1234*****0';
  hideStaffCId: boolean = false;
  hidePatientCId: boolean = false;
  oneSide: boolean = false;
  fullPage: boolean = false;
  continuousPrint: boolean = false;
  medicalCombine: boolean = false;
  excludeAmount: boolean = false;
  excludeSPRule: boolean = false;
  excludeStdCode: boolean = false;
  excludeSelfPay: boolean = false;
  historyReport = 102;
  stdCodeWidth: number;
  pageSizeType: number = 1;
  pageSize: string = 'A4';
  pageClass: string = 'a4-print-style-h';
  /** 送印樣式節點的 id，用於在重新填資料時取代前一份而非累加。 */
  static readonly PRINT_STYLE_ID = 'print-style-hist-original';

  constructor(
    private localPrintService: LocalPrintService,
    private notification: EasyNotificationService,
    private hcrService: HcrService,
    private clinicDataService: ClinicDataService,
    private cidMaskPipe: CidMaskPipe
  ) {}

  async ngOnInit() {
    var codes = await this.clinicDataService.getSystemCodes(['C0010']);
    this.icodes = [{ value: '', text: '' }].concat(codes['C0010']);
    var param = await this.clinicDataService.getParam("PRN001");
    this.cidMask = isNaN(Number(param.IDHidePRN)) ? param.IDHidePRN : this.cidMask;//如果參數有設定遮罩以參數為主。

    // var st = document.createElement('style');
    // st.appendChild(document.createTextNode(
    //   '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
    //   '.pres-report2 table{ border:0px solid black; border-collapse: collapse; }\n' +
    //   '.pres-report2 table td, table th { border-bottom: 0px solid black; padding-left: 0px;padding-right: 0px;}\n' +//調整左右padding 5px->0px
    //   '.pres-report2 table tr:first-child th { border-top: 0; vertical-align: bottom; padding: 0px }\n' +
    //   '.pres-report2 table tr:last-child td { border-bottom: 0; }\n' +
    //   '.pres-report2 table tr td:first-child, table tr th:first-child { border-left: 0; }\n' +
    //   '.pres-report2 table tr td:last-child, table tr th:last-child { border-right: 0; }\n' +
    //   '.pres-report2 table tr { line-height: 20px; }\n' +//調整每行高度
    //   '@page { size: ' + this.pageSize + '; margin: 0.5cm 0.5cm; }\n'
    // ));
    // setTimeout(() => {
    //   this.reportContainer.nativeElement.appendChild(st);
    // }, 0);
  }

  clearData() {
    this.totalRecord = 0;
    if (this.elContainer)
      this.elContainer.innerHTML = '';
  }

  fillData(data: HistPrintOriginalDataDto[], hideStaffCId: boolean, hidePatientCId: boolean, oneSide: boolean = false, fullPage: boolean = false, medicalCombine: boolean = false, excludeSelfPay: boolean = false, continuousPrint: boolean = false, printSize: number = 1) {
    // create style for print
    this.pageSizeType = printSize;
    this.applyPageMetrics();
    this.pageClass = (printSize == 1 ? 'a4-print-style-h' : (printSize == 2 ? 'vis1o2' : (printSize == 3 ? 'vis1o3' : 'otherSize')));
    this.pageSize = (printSize == 1 ? 'A4' : (printSize == 2 ? '21.5cm 9.3cm' : (printSize == 3 ? '21.5cm 13.5cm' : '21.5cm 18.6cm')));

    var st = document.createElement('style');
    st.id = ReportHistPrintOriginalComponent.PRINT_STYLE_ID;
    st.appendChild(document.createTextNode(this.buildPrintStyleText()));
    setTimeout(() => {
      var old = this.reportContainer.nativeElement.querySelector('#' + ReportHistPrintOriginalComponent.PRINT_STYLE_ID);
      if (old) old.remove();
      this.reportContainer.nativeElement.appendChild(st);
    }, 0);

    this.elContainer = document.getElementById("container");
    this.reportData = data;
    this.hideStaffCId = hideStaffCId;
    this.hidePatientCId = hidePatientCId;
    this.excludeSelfPay = excludeSelfPay;
    this.oneSide = oneSide;
    this.fullPage = fullPage;
    if (fullPage) {
      this.oneSide = true;
    }
    this.continuousPrint = continuousPrint;
    this.stdCodeWidth = this.fullPage ? 12 : 23;
    this.medicalCombine = medicalCombine;
    this.reportName = '病歷表(原紙張大小)';//報表上沒印出
    this.shortReportName = '原紙張病歷表';
    this.forExcel = true;
    this.commonClass = this.forExcel ? 'class="excel-format"' : '';
    this.commonClassText = this.forExcel ? 'class="excel-format-text"' : '';
    this.totalRecord = this.reportData.length;
    this.nowStr = DateHelper.getROCDateStringWithSepetator(DateHelper.today);
    this.timeStr = DateHelper.getTimeString(new Date(), ':', true);

    // 組報表的html內容
    this.insertReportDataPaged();
  }

  /**
   * 依 pageSizeType 設定紙張尺寸，並同步重算單頁可用高度。
   * heightPageWithoutPadding 是分頁判斷溢出的唯一門檻，任何變更 pageSizeType 的位置
   * 都必須先呼叫本方法，否則分頁仍以 A4 高度判斷。
   */
  applyPageMetrics() {
    if (this.pageSizeType == 1) {
      // A4 21.0×29.7cm 扣除主控台列印邊距(四邊各 1cm，NoMargin 無 UI 可設定，恆為 false)。
      // 頁框大於實際可列印區時，超出的內容會被列印引擎切到次頁，與次頁內容疊印。
      this.sizePage.width = 18.8;
      this.sizePage.height = 27.4;
    } else if (this.pageSizeType == 2) {
      this.sizePage.width = 21.5;
      this.sizePage.height = 13.4;
    } else if (this.pageSizeType == 3) {
      this.sizePage.width = 21.5;
      this.sizePage.height = 9.1;
    } else if (this.pageSizeType == 4) {
      this.sizePage.width = 21.5;
      this.sizePage.height = 18.5;
    }
    this.heightPageWithoutPadding = this.convertCmtoPx(
      this.sizePage.height - (this.paddingPage.top + this.paddingPage.bottom)
    ) - 20; // 量測在瀏覽器、輸出在 WebView2，保留一行(line-height 20px)吸收兩者的渲染差
  }

  insertReportData() {
    var listItems = this.reportData;
    var html_Block = "";
    var iPage = 0;
    var iBlock = 0;
    this.elContainer.innerHTML = this.createHTMLPage(iPage);                                 // 整份報表的html內容
    var html_header = this.createHTMLPageHeader(iPage);                                      // 頁表頭
    var html_ListerHeader = this.createHTMLListHeader(listItems[0]);                         // List欄位顯示名稱
    var html_finish = this.createHTMLFinish();                                               // 報表結束 -- 以下空白
    var elPageContent = document.getElementById("page-" + iPage + "-content");               // 取得某頁的content，每次查詢後會取第0頁
    var prevTableContent: any;
    var afterSummary = false;
    // 組報表內容
    // [頁表頭][List欄位顯示名稱]
    elPageContent.innerHTML = html_header;
    var elTableContent = document.getElementById("table-" + iPage + "-content");
    elTableContent.innerHTML = html_ListerHeader;
    var j: number = 0;
    var overPage = listItems.map(x => false);
    var patientId = 0;
    for (let i = 0; i < listItems.length; i++) {
        // 加入 List 每一筆的內容
        prevTableContent = elTableContent.innerHTML;
        if (afterSummary) {
            elTableContent.innerHTML += this.createHTMLListHeader(listItems[i]);
            afterSummary = false;
        }
        if (listItems[i].IsSummary) {
            html_Block = this.createHTMLSummary(listItems[i].SummaryAmount, j);
            afterSummary = true;
            j = 0;
        } else {
            html_Block = this.createHTMLBlock(listItems[i]);
            j++;
        }
        //此報表每筆資料都是一頁,html內容直接給,不用加。
        // elTableContent.innerHTML += html_Block;
        //調整成不跳頁時,每筆資料都加上
        if (!this.continuousPrint) {
          elTableContent.innerHTML = html_Block;
        } else {
          elTableContent.innerHTML += html_Block;
        }
        // 判斷是否超出頁面範圍? -> 新增一頁
        //IsMasterFirst=不同Patient跳頁用
        overPage[i] = elPageContent.offsetHeight > this.heightPageWithoutPadding;
        //連續印時同Patient會排再一起，控制不同Patient跳頁。
        if (this.continuousPrint && !overPage[i] && patientId !== 0 && patientId !== listItems[i].Master.PatientId) {
          overPage[i] = true;
        }
        patientId = listItems[i].Master.PatientId;
        // if ((i > 0 && listItems[i].IsMasterFirst) || elPageContent.offsetHeight > this.heightPageWithoutPadding) {
        if ((i > 0 && listItems[i].IsMasterFirst && !this.continuousPrint) || (i > 0 && overPage[i])) {
          elTableContent.innerHTML = prevTableContent;

          //由於每筆資料都是一頁,當資料主訴長及醫令多時,會超出頁面範圍,需多一頁空白,讓超出資料顯示在下一頁。連續印不判斷。
          //if (!this.continuousPrint && overPage[i - 1]) {
          if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
            iPage += 1;
            this.elContainer.innerHTML += this.createHTMLPage(iPage);
            elPageContent = document.getElementById("page-" + iPage + "-content");
            // [頁表頭][List欄位顯示名稱]
            html_header = this.createHTMLPageHeader(iPage);
            elPageContent.innerHTML += html_header;
            elTableContent = document.getElementById("table-" + iPage + "-content");
            elTableContent.innerHTML = '';

            this.pageContent[iPage] = [];
            this.pageContent[iPage].push(iBlock);
          }

          iPage += 1;
          this.elContainer.innerHTML += this.createHTMLPage(iPage);
          elPageContent = document.getElementById("page-" + iPage + "-content");
          // [頁表頭][List欄位顯示名稱]
          html_header = this.createHTMLPageHeader(iPage);
          elPageContent.innerHTML += html_header;
          elTableContent = document.getElementById("table-" + iPage + "-content");
          if (listItems[i].IsSummary) {
              elTableContent.innerHTML = this.createHTMLListHeader(listItems[i-1]);
          } else {
              elTableContent.innerHTML = this.createHTMLListHeader(listItems[i]);
          }
          elTableContent.innerHTML += html_Block;

          this.pageContent[iPage] = [];
          this.pageContent[iPage].push(iBlock);
        } else {
          this.pageContent[iPage].push(iBlock);
        }

        iBlock += 1;
    }
    elPageContent.innerHTML +=  html_finish;
    this.upperboundIndex = iPage;
  }

  /**
   * 內容級分頁引擎。
   *
   * 兩階段：先把每一聯切成「每格一頁」的字串陣列，再逐頁把左右聯配對成 <tr>。
   * 左右聯各自依自己的高度切頁，先印完的一聯在後續頁面留白。
   * 主訴、PE 過長時斷點續印，續頁不重印任何表頭欄位。
   *
   * 與 insertReportData()（每筆固定一頁、溢出補空白頁）互為替代，fillData() 決定採用哪一個。
   */
  insertReportDataPaged() {
    const listItems = this.reportData ?? [];
    this.elContainer.innerHTML = '';
    this.pageContent = [[]];
    if (listItems.length === 0) {
      this.upperboundIndex = 0;
      return;
    }

    // 連續印時同一位病患的多筆病歷排在同一頁，換病患才跳頁；非連續印則每筆病歷自成一組。
    const groups: HistPrintOriginalDataDto[][] = [];
    if (this.continuousPrint) {
      let group: HistPrintOriginalDataDto[] = [];
      for (const dto of listItems) {
        if (group.length > 0 && group[0].Master.PatientId !== dto.Master.PatientId) {
          groups.push(group);
          group = [];
        }
        group.push(dto);
      }
      if (group.length > 0) groups.push(group);
    } else {
      listItems.forEach(dto => groups.push([dto]));
    }

    const composed: { left: string, right: string }[] = [];
    const measure = this.createMeasureContext();
    try {
      for (const group of groups) {
        const leftUnits: PageUnit[] = [];
        const rightUnits: PageUnit[] = [];
        group.forEach(dto => {
          leftUnits.push(...this.buildSideUnits(dto, 'Left'));
          if (!this.oneSide) rightUnits.push(...this.buildSideUnits(dto, 'Right'));
        });

        const leftPages = measure.paginator.paginate(leftUnits);
        const rightPages = this.oneSide ? [] : measure.paginator.paginate(rightUnits);
        const total = Math.max(leftPages.length, rightPages.length, 1);
        for (let k = 0; k < total; k++) {
          composed.push({ left: leftPages[k] ?? '', right: rightPages[k] ?? '' });
        }
      }
    } finally {
      measure.dispose();
    }

    let pagesHtml = '';
    for (let i = 0; i < composed.length; i++) {
      pagesHtml += this.createHTMLPage(i);
    }
    this.elContainer.innerHTML = pagesHtml;

    for (let i = 0; i < composed.length; i++) {
      document.getElementById("page-" + i + "-content").innerHTML = this.createHTMLPageHeader(i);
      document.getElementById("table-" + i + "-content").innerHTML =
        this.composeRow(composed[i].left, composed[i].right);
      this.pageContent[i] = [i];
    }

    this.upperboundIndex = composed.length - 1;
  }

  /**
   * 組出一聯的分頁單元序列，順序與 createHTMLListHeaderExt() + createHTMLBlock() 的輸出一致。
   * 主訴與 PE 為可拆單元，其餘皆不可拆。
   * 醫令列共用一個 <table>，由 resumeAfter 負責在續頁重開該 table（不重印欄位標題）；
   * 醫師與金額段以 </table> 開頭收掉醫令 table，並用 resumeBefore 還原成無 wrap 狀態。
   */
  buildSideUnits(dto: HistPrintOriginalDataDto, side: 'Left' | 'Right'): PageUnit[] {
    const data = dto.Master;
    const items = dto.Items;
    const units: PageUnit[] = [];

    units.push({ kind: 'fixed', html: this.renderInfoHead(data, side) });

    const cc = data.CC.trim();
    units.push(cc
      ? { kind: 'text', text: cc, render: (part) => this.renderCCPart(part) }
      : { kind: 'fixed', html: this.renderCCPart('') });

    const pe = data.PE.trim();
    if (pe) {
      units.push({ kind: 'text', text: pe, render: (part, isFirst) => this.renderPEPart(part, isFirst) });
    }

    units.push({ kind: 'fixed', html: this.renderInfoTail(data, side) });
    units.push({
      kind: 'fixed',
      html: this.createHTMLBlockHead(items, side),
      wrapAfter: { resume: `<table style="width:100%; font-size: 12pt;">`, suffix: `</table>` }
    });
    items.forEach(item => units.push({ kind: 'fixed', html: this.renderRxRow(item, side) }));
    units.push({
      kind: 'fixed',
      html: this.createHTMLBlockLast(data, side),
      wrapBefore: { resume: '', suffix: '' }
    });

    if (this.medicalCombine) {
      units.push(...this.buildCombineUnits(dto.CombineItems, side));
    }

    return units;
  }

  /** 把左右兩聯的單頁內容組成 <tr>，欄寬與 createHTMLBlock() 相同。 */
  composeRow(left: string, right: string) {
    return !this.fullPage ? `
      <tr>
        <td style="width:49.5%; vertical-align:top;">
          ${left}
        </td>

        <td style="width:1%; vertical-align:top;">
          <table style="width:100%; font-size: 12pt;">
            <tr><td>&nbsp;</td></tr>
          </table>
        </td>

        <td style="width:49.5%; vertical-align:top;">
          ${right}
        </td>
      </tr>
    `
    : `
      <tr>
        <td style="width:100%; vertical-align:top;">
          ${left}
        </td>
      </tr>
    `;
  }

  /**
   * 建立離屏量測頁：與正式頁同構（同樣的 createHTMLPage / createHTMLPageHeader 與儲存格寬度），
   * 才能量到與實際輸出一致的高度。移出視野而非 display:none，否則量不到高度。
   * 呼叫端必須在用完後呼叫 dispose()。
   */
  createMeasureContext(): { paginator: ReportPagePaginator, dispose: () => void } {
    const host = document.createElement('div');
    host.style.cssText = 'position:absolute; left:-10000px; top:0; visibility:hidden;';
    host.style.width = this.sizePage.width + 'cm';
    host.innerHTML = this.createHTMLPage('m');
    this.elContainer.parentElement.appendChild(host);

    const elMeasurePage = host.querySelector('#page-m-content') as HTMLElement;
    elMeasurePage.innerHTML = this.createHTMLPageHeader('m');
    (host.querySelector('#table-m-content') as HTMLElement).innerHTML = !this.fullPage ? `
      <tr>
        <td id="cell-m" style="width:49.5%; vertical-align:top;"></td>
        <td style="width:1%; vertical-align:top;">
          <table style="width:100%; font-size: 12pt;">
            <tr><td>&nbsp;</td></tr>
          </table>
        </td>
        <td style="width:49.5%; vertical-align:top;"></td>
      </tr>
    ` : `
      <tr>
        <td id="cell-m" style="width:100%; vertical-align:top;"></td>
      </tr>
    `;
    const cell = host.querySelector('#cell-m') as HTMLElement;

    return {
      paginator: new ReportPagePaginator(cell, elMeasurePage, this.heightPageWithoutPadding),
      dispose: () => host.parentElement && host.parentElement.removeChild(host)
    };
  }

  convertPxToCm(px) {
    return Math.round(((px * 2.54) / 96) * 100) / 100;
  }

  convertCmtoPx(cm) {
    return Math.round((cm * 96) / 2.54);
  }

  createHTMLPage(iPage) {
    var page = '';
    this.applyPageMetrics();
    //強制儲存格轉文字mso-number-format
    if (this.forExcel) {
      page += `
        <style>
          .excel-format {
            font-size: 12pt;
          }
          .excel-format-text {
            font-size: 12pt;
            mso-number-format: "@";
          }
        </style>`;
    }
    //margin: 0px auto; 若設5px，只印一頁時，輸出pdf會多一頁空白。
    page += `
      <div class="page" id="page-` + iPage + `"
        style="
        min-height: ` + this.sizePage.height + `cm;
        width: ` + this.sizePage.width + `cm;
        padding-top: ` + this.paddingPage.top + `cm;
        padding-right: ` + this.paddingPage.right + `cm;
        padding-bottom: ` + this.paddingPage.bottom + `cm;
        padding-left: ` + this.paddingPage.left + `cm;
        display: block;
        margin: 0px auto;
        box-shadow: 0 0 0.15cm rgba(0, 0, 0, 0.15);
        box-sizing: border-box;
        background-color: white;
        ">
        <div class="content" id="page-` + iPage + `-content">
        </div>
      </div>`;
    return page;
  }

  createHTMLPageHeader(iPage) {
    return `
      <div id="header" style="margin: 0px 10px;">
        <div style="display: flex;column-gap: 5px;">
          <table style="width: 100%; text-align: center; border: none;">
            <tr>
              <td colspan="9" style="height: 1px; text-align: center; font-weight: bolder; font-size: 16pt; border-right: none; border-left: none; border-bottom: none; border-top: none; font-family: 細明體;">

              </td>
            </tr>
          </table>
        </div>
      </div>

      <div style="-webkit-text-size-adjust: none; font-size: 8pt; zoom: 0.8; margin: 0px 2px; text-align: center; height: 1px;">
        <label style="font-weight: bold; height: 1px;"></label>
      </div>
      <div style="-webkit-text-size-adjust: none; font-size: 12pt; zoom: 0.8; margin: 0px 10px; font-family: 細明體;">
        <div style="display: flex;column-gap: 5px;">
          <table id="table-` + iPage + `-content" style="width: 100%; font-size: 12pt; text-align: center; border: none;"></table>
        </div>
      </div>`;
  }

  createHTMLListHeader(dto?: HistPrintOriginalDataDto) {
    // 改到createHTMLBlock()去執行。
    return '';
  }

  /**
   * 表頭全段。四個區塊的順序為：基本資料、主訴、PE、就診分類，
   * 與分頁引擎 buildSideUnits() 組出的單元順序必須一致。
   */
  createHTMLListHeaderExt(data?: HistPrintOperationDataDto, side?: 'Left' | 'Right') {
    let pe = data.PE.trim();
    return this.renderInfoHead(data, side)
      + this.renderCCPart(data.CC.trim())
      + (pe ? this.renderPEPart(pe, true) : '')
      + this.renderInfoTail(data, side);
  }

  /** 表頭前半：姓名、日期、門診登錄。主訴之前的欄位，不可拆。 */
  renderInfoHead(data: HistPrintOperationDataDto, side?: 'Left' | 'Right') {
    let iCodeName = this.icodes.find(i => i.value === data.ICode)?.text ?? data.ICode;
    let showICodeName = (iCodeName.length > 4 ? '身:' : '身份:') + iCodeName;
    let cid = this.hidePatientCId ? this.cidMaskPipe.transform(data.CId, this.cidMask) : data.CId;
    let showCid = (iCodeName.length > 4 ? '證:' : '身份證:') + cid;
    let regDate = data.Date ? DateHelper.getROCFullDateString(new Date(data.Date), '') : '';
    let showRegisterRemark = side === 'Right' ? data.RegisterRemark : '';
    let showSpace = this.continuousPrint ? `
            <tr><td><table style="width:100%; font-size: 12pt;">
              <tr>
                <td>　</td>
              </tr>
            </table></td></tr>
    ` : '';

    return `
          <table style="width:100%; font-size: 12pt;">

            ${showSpace}

            <tr><td><table style="width:100%; font-size: 12pt;">
              <tr>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>姓名:${data.PatientNoAndName}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${showICodeName}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${showCid}</td>
              </tr>
            </table></td></tr>

            <tr><td><table style="width:100%; font-size: 12pt;">
              <tr>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>日期:${regDate}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>卡:${data.Isqno}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>院所:${data.NHICode}${data.ClinicName}</td>
              </tr>
            </table></td></tr>

            <tr><td><table style="width:100%; font-size: 12pt;">
              <tr>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>門診登錄: ${showRegisterRemark}</td>
              </tr>
            </table></td></tr>

          </table>
      `;
  }

  /**
   * 主訴，可跨頁切段。空字串仍會輸出一個空行，維持與有主訴時相同的版面高度。
   * 每段樣式與整段時完全相同，續段不加任何前綴。
   */
  renderCCPart(part: string) {
    return `
          <table style="width:100%; font-size: 12pt;">
            <tr>
              <td style="text-align: left; white-space: pre-wrap; overflow-wrap: break-word; word-break: break-all; ${this.commonStyle}" ${this.commonClass}>${part}</td>
            </tr>
          </table>
      `;
  }

  /** PE，可跨頁切段。"PE:" 前綴只出現在首段。 */
  renderPEPart(part: string, isFirstPart: boolean) {
    return `
          <table style="width:100%; font-size: 12pt;">
            <tr>
              <td style="text-align: left; white-space: pre-wrap; overflow-wrap: break-word; word-break: break-all; ${this.commonStyle}" ${this.commonClass}>${isFirstPart ? 'PE:' : ''}${part}</td>
            </tr>
          </table>
      `;
  }

  /** 表頭後半：體位、國病別、科別案類。主訴之後的欄位，不可拆。 */
  renderInfoTail(data: HistPrintOperationDataDto, side?: 'Left' | 'Right') {
    let birthday = data.Birthday ? DateHelper.getROCFullDateString(new Date(data.Birthday)) : '';
    let showTreat = '';
    if (data.CusNo && data.CntPresNo) {
      showTreat = `(療${data.CusNo}/${data.CusTot},慢${data.CntPresNo}/${data.CntPresTot})`;
    }
    else if (data.CusNo) {
      showTreat = `(${data.CusNo}/${data.CusTot})`;
    }
    else if (data.CntPresNo) {
      showTreat = `(${data.CntPresNo}/${data.CntPresTot})`;
    }
    showTreat = showTreat ? '　' + showTreat : '';
    let showBP = (data.SBP && data.DBP) ? `${data.SBP}/${data.DBP}` : '';
    let showBMI = side === 'Right' ? `
            <tr><td><table style="width:100%; font-size: 12pt;">
              <tr>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>體重:${data.Weight !== 0 ? data.Weight + 'kg' : ''}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>體溫:${data.BT !== 0 ? data.BT + '℃' : ''}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>血壓:${showBP}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>BMI:${data.BMI !== 0 ? data.BMI : ''}</td>
              </tr>
            </table></td></tr>
      ` : `
            <tr><td><table style="width:100%; font-size: 12pt;">
              <tr>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${data.Weight !== 0 ? '體重:' + data.Weight + 'kg' : (!this.continuousPrint ? '　' : '')}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${data.BT !== 0 ? '體溫:' + data.BT + '℃' : ''}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${showBP ? '血壓:' + showBP : ''}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${data.BMI !== 0 ? 'BMI:' + data.BMI : ''}</td>
              </tr>
            </table></td></tr>
      `;
    let showNoSpace = !this.continuousPrint ? `
            <tr><td><table style="width:100%; font-size: 12pt;">
              <tr>
                <td>　</td>
              </tr>
            </table></td></tr>
    ` : '';

    return `
          <table style="width:100%; font-size: 12pt;">

            ${showNoSpace}

            ${showBMI}

            <tr><td><table style="width:100%; font-size: 12pt;">
              <tr>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>國病別:${data.AllDxName}${showTreat}</td>
              </tr>
            </table></td></tr>

            <tr><td><table style="width:100%; font-size: 12pt;">
              <tr>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>科　別:${data.Dept}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>案類:${data.Case}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>日份:${data.DeclareDays}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>調劑:${data.DispTP}</td>
                <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>生日:${birthday}</td>
              </tr>
            </table></td></tr>

          </table>
      `;
  }

  createHTMLBlock(dto: HistPrintOriginalDataDto) {
    let data = dto.Master;
    let items = dto.Items;
    //當醫令合併時，且非第一筆醫令，不顯示醫令標題。
    let combine = this.medicalCombine;

    let leftHeader = this.createHTMLListHeaderExt(data, 'Left');
    let rightHeader = this.oneSide ? '' : this.createHTMLListHeaderExt(data, 'Right');

    let leftBlock = this.createHTMLBlockHead(items, 'Left');
    let rightBlock = this.oneSide ? '' : this.createHTMLBlockHead(items, 'Right');

    leftBlock += this.createHTMLBlockItem(items, 'Left');
    rightBlock += this.oneSide ? '' : this.createHTMLBlockItem(items, 'Right');

    let leftLast = this.createHTMLBlockLast(data, 'Left');
    let rightLast = this.oneSide ? '' : this.createHTMLBlockLast(data, 'Right');

    let leftCombine = !combine ? '' : this.createHTMLBlockCombine(dto.CombineItems, 'Left');
    let rightCombine = !combine ? '' : this.oneSide ? '' : this.createHTMLBlockCombine(dto.CombineItems, 'Right');

    leftBlock += `
          </table>
          ${leftLast}`;

    rightBlock += `
          </table>
          ${rightLast}`;

    //左邊td一個病歷, 中間td空白, 右邊td一個病歷(同一人同一病歷,左右格式有些差異)
    let text = !this.fullPage ? `
      <tr>
        <td style="width:49.5%; vertical-align:top;">
          ${leftHeader}
          ${leftBlock}
          ${leftCombine}
        </td>

        <td style="width:1%; vertical-align:top;">
          <table style="width:100%; font-size: 12pt;">
            <tr><td>&nbsp;</td></tr>
          </table>
        </td>

        <td style="width:49.5%; vertical-align:top;">
          ${rightHeader}
          ${rightBlock}
          ${rightCombine}
        </td>
      </tr>
    `
    : `
      <tr>
        <td style="width:100%; vertical-align:top;">
          ${leftHeader}
          ${leftBlock}
          ${leftCombine}
        </td>
      </tr>
    `;

    return text;
  }

  createHTMLBlockHead(items: HistPrintOperationDataItemDto[], side?: 'Left' | 'Right') {
    let qtyLabel = (items.length > 0 && items[0].QtyRule === HistOrder.QtyRule_DailyDose) ? '日量' : '劑量';

    var StdCodeTitle = `<td style="text-align: left;   width:  ${this.stdCodeWidth}%; ${this.commonStyle1}" ${this.commonClass}>健保碼</td>`;
    var SpRuleTitle = `<td style="text-align: center; width:   3%; ${this.commonStyle1}" ${this.commonClass}>N</td>`;
    var AmountTitle = `<td style="text-align: right;  width:   8%; ${this.commonStyle1}" ${this.commonClass}>單價</td>`;
    if (this.excludeStdCode == true) {
      StdCodeTitle = ``;
    }
    if (this.excludeSPRule == true) {
      SpRuleTitle = ``;
    }
    if (this.excludeAmount == true) {
      AmountTitle = ``;
    }
    return side === 'Left' ? `
          <table style="width:100%; font-size: 12pt;">
            <tr>`
              + StdCodeTitle
              + SpRuleTitle + `
              <td style="text-align: left;                ${this.commonStyle1}" ${this.commonClass}>藥材/治療</td>
              ` + AmountTitle + `
              <td style="text-align: right;  width: 8.2%; ${this.commonStyle1}" ${this.commonClass}>${qtyLabel}</td>
              <td style="text-align: center; width:   6%; ${this.commonStyle1}" ${this.commonClass}>UN</td>
              <td style="text-align: center; width:  10%; ${this.commonStyle1}" ${this.commonClass}>頻率</td>
              <td style="text-align: right;  width:   6%; ${this.commonStyle1}" ${this.commonClass}>日</td>
              <td style="text-align: right;  width: 8.2%; ${this.commonStyle1}" ${this.commonClass}>總量</td>
              <td style="text-align: center; width: 8.2%; ${this.commonStyle1}" ${this.commonClass}>途徑</td>
            </tr>
        ` : `
          <table style="width:100%; font-size: 12pt;">
            <tr>`
              + SpRuleTitle + `
              <td style="text-align: left;                ${this.commonStyle1}" ${this.commonClass}>藥材/治療</td>
              <td style="text-align: right;  width:   8%; ${this.commonStyle1}" ${this.commonClass}>${qtyLabel}</td>
              <td style="text-align: center; width:   6%; ${this.commonStyle1}" ${this.commonClass}>UN</td>
              <td style="text-align: center; width:  10%; ${this.commonStyle1}" ${this.commonClass}>頻率</td>
              <td style="text-align: right;  width:   6%; ${this.commonStyle1}" ${this.commonClass}>日</td>
              <td style="text-align: center; width:   5%; ${this.commonStyle1}" ${this.commonClass}>註</td>
              <td style="text-align: right;  width:   8%; ${this.commonStyle1}" ${this.commonClass}>總量</td>
            </tr>
        `;
  }

  createHTMLBlockItem(items: HistPrintOperationDataItemDto[], side?: 'Left' | 'Right') {
    let text = '';
    for (let i = 0; i < items.length; i++) {
      text += this.renderRxRow(items[i], side);
    };
    return text;
  }

  /**
   * 單筆醫令。右聯的第二品名與本行同屬一個不可拆單元，分頁時不會被拆開。
   * 回傳的是 <tr>，必須置於 createHTMLBlockHead() 開出的 <table> 之內。
   */
  renderRxRow(item: HistPrintOperationDataItemDto, side?: 'Left' | 'Right') {
    var StdCodeTitle = `<td style="text-align: left;   width:  ${this.stdCodeWidth}%; ${this.commonStyle}" ${this.commonClassText}>${item.StdCode}</td>`;
    var SpRuleTitle = `<td style="text-align: center; width:   3%; ${this.commonStyle}" ${this.commonClass}>${item.SPRule !== 0 ? item.SPRule : ''}</td>`;
    var AmountTitle = `<td style="text-align: right;  width:   8%; ${this.commonStyle}" ${this.commonClass}>${item.IPrice}</td>`;
    if (this.excludeStdCode == true) {
      StdCodeTitle = ``;
    }
    if (this.excludeSPRule == true) {
      SpRuleTitle = ``;
    }
    if (this.excludeAmount == true) {
      AmountTitle = ``;
    }
    if (side === 'Left') {
      return `
            <tr>`
            + StdCodeTitle
            + SpRuleTitle + `
              <td style="text-align: left;                ${this.commonStyle}" ${this.commonClassText}>${this.stringFactory(item.ProdName, this.fullPage ? 32 : 12)}</td>
              ` + AmountTitle + `
              <td style="text-align: right;  width: 8.2%; ${this.commonStyle}" ${this.commonClass}>${item.QTY}</td>
              <td style="text-align: center; width:   6%; ${this.commonStyle}" ${this.commonClass}>${item.Unit}</td>
              <td style="text-align: center; width:  10%; ${this.commonStyle}" ${this.commonClass}>${item.FreqName}</td>
              <td style="text-align: right;  width:   6%; ${this.commonStyle}" ${this.commonClass}>${item.Days}</td>
              <td style="text-align: right;  width: 8.2%; ${this.commonStyle}" ${this.commonClass}>${item.TotalDose}</td>
              <td style="text-align: center; width: 8.2%; ${this.commonStyle}" ${this.commonClass}>${item.Way}</td>
            </tr>
          `;
    }

    var SpRuleTitle2 = `<td style="text-align: center; ${this.commonStyle}" ${this.commonClass}></td>`;
    if (this.excludeSPRule == true) {
      SpRuleTitle2 = ``;
    }

    let rightFirstName = item.IIName ? item.IIName : item.ProdName;
    rightFirstName = this.stringFactory(rightFirstName, 26);
    let rightSecondName = item.GXName;
    let showSecondName = this.printSecondName && rightSecondName ? `
            <tr>`
            + SpRuleTitle2 + `
              <td colspan="7" style="text-align: left;   ${this.commonStyle}" ${this.commonClass}>${rightSecondName}</td>
            </tr>
        ` : '';

    return `
            <tr>`
            + SpRuleTitle + `
              <td style="text-align: left;                ${this.commonStyle}" ${this.commonClassText}>${rightFirstName}</td>
              <td style="text-align: right;  width:   8%; ${this.commonStyle}" ${this.commonClass}>${item.QTY}</td>
              <td style="text-align: center; width:   6%; ${this.commonStyle}" ${this.commonClass}>${item.Unit}</td>
              <td style="text-align: center; width:  10%; ${this.commonStyle}" ${this.commonClass}>${item.Freq}</td>
              <td style="text-align: right;  width:   6%; ${this.commonStyle}" ${this.commonClass}>${item.Days}</td>
              <td style="text-align: center; width:   5%; ${this.commonStyle}" ${this.commonClassText}>${item.Remark.slice(0, 1)}</td>
              <td style="text-align: right;  width:   8%; ${this.commonStyle}" ${this.commonClass}>${item.TotalDose}</td>
            </tr>
            ${showSecondName}
          `;
  }

  createHTMLBlockLast(data: HistPrintOperationDataDto, side?: 'Left' | 'Right') {
    let drName = '';
    if (data.DrID) {
      let drID = this.hideStaffCId ? this.cidMaskPipe.transform(data.DrID, this.cidMask) : data.DrID;
      drName = '醫師:' + drID + data.DoctorName;
    }
    let phName = '';
    if (data.PharID) {
      let phID = this.hideStaffCId ? this.cidMaskPipe.transform(data.PharID, this.cidMask) : data.PharID;
      phName = '藥師:' + phID + data.PharmacistName;
    }
    let showDoctor = `
          <tr><td><table style="width:100%; font-size: 12pt;">
            <tr>
              <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${drName}</td>
              <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${phName}</td>
            </tr>
          </table></td></tr>
    `;
    let showAPartRx = data.APartRx ? `★藥自付:${data.APartRx}★` : '';
    let showAPartExam = data.APartExam ? `★檢驗自付:${data.APartExam}★` : '';

    var resHtml = side === 'Left' ? `
          <table style="width:100%; font-size: 12pt;">

            ${showDoctor}

          ` : `
          <table style="width:100%; font-size: 12pt;">

            ${showDoctor} `;

    // 顯示金額
    if (this.excludeAmount == false) {
      var resHtml2 = side === 'Left' ? `
                <tr><td><table style="width:100%; font-size: 12pt;">
                  <tr>
                    <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>診察${data.ADx !== 0 ? data.ADx : ''}</td>
                    <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>藥費${data.ARx !== 0 ? data.ARx : ''}</td>
                    <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>治療${data.ATx !== 0 ? data.ATx : ''}</td>
                    <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>藥事${data.AMed !== 0 ? data.AMed : ''}</td>
                    <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>申請${data.ADcl !== 0 ? data.ADcl : ''}</td>
                  </tr>
                  <tr>
                    <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>掛費${data.FeeReg !== 0 ? data.FeeReg : ''}</td>
                    <td colspan="4" style="text-align: left; ${this.commonStyle}" ${this.commonClass}>自付${data.APartOPD !== 0 ? data.APartOPD : ''} ${showAPartRx} ${showAPartExam}</td>
                  </tr>
                  <tr>
                    <td colspan="2" style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${data.AOwn !== 0 && !this.excludeSelfPay ? '[自費:' + data.AOwn + ']' : ''}</td>
                  </tr>
                </table></td></tr>

              </table>
              ` : `
               <tr><td><table style="width:100%; font-size: 12pt;">
                  <tr>
                    <td style="text-align: left; width:25%; ${this.commonStyle}" ${this.commonClass}>自付:${data.APartOPD !== 0 ? data.APartOPD : ''}</td>
                    <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>掛費:${data.FeeReg !== 0 ? data.FeeReg : ''} ${showAPartRx} ${showAPartExam}</td>
                  </tr>
                  <tr>
                    <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${data.AOwn !== 0 && !this.excludeSelfPay ? '[自費:' + data.AOwn + ']' : (this.printSecondName ? '' : '　')}</td>
                  </tr>
                </table></td></tr>

              </table>
          `;
      resHtml = resHtml + resHtml2;
    } else {
      resHtml = resHtml + `</table>`;
    }
    // var result = side === 'Left' ? `
    //     <table style="width:100%; font-size: 12pt;">

    //       ${showDoctor}

    //       <tr><td><table style="width:100%; font-size: 12pt;">
    //         <tr>
    //           <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>診察${data.ADx !== 0 ? data.ADx : ''}</td>
    //           <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>藥費${data.ARx !== 0 ? data.ARx : ''}</td>
    //           <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>治療${data.ATx !== 0 ? data.ATx : ''}</td>
    //           <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>藥事${data.AMed !== 0 ? data.AMed : ''}</td>
    //           <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>申請${data.ADcl !== 0 ? data.ADcl : ''}</td>
    //         </tr>
    //         <tr>
    //           <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>掛費${data.FeeReg !== 0 ? data.FeeReg : ''}</td>
    //           <td colspan="4" style="text-align: left; ${this.commonStyle}" ${this.commonClass}>自付${data.APartOPD !== 0 ? data.APartOPD : ''} ${showAPartRx} ${showAPartExam}</td>
    //         </tr>
    //         <tr>
    //           <td colspan="2" style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${data.AOwn !== 0 ? '[自費:' + data.AOwn + ']' : ''}</td>
    //         </tr>
    //       </table></td></tr>

    //     </table>
    //     ` : `
    //     <table style="width:100%; font-size: 12pt;">

    //       ${showDoctor}

    //       <tr><td><table style="width:100%; font-size: 12pt;">
    //         <tr>
    //           <td style="text-align: left; width:25%; ${this.commonStyle}" ${this.commonClass}>自付:${data.APartOPD !== 0 ? data.APartOPD : ''}</td>
    //           <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>掛費:${data.FeeReg !== 0 ? data.FeeReg : ''} ${showAPartRx} ${showAPartExam}</td>
    //         </tr>
    //         <tr>
    //           <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>${data.AOwn !== 0 ? '[自費:' + data.AOwn + ']' : (this.printSecondName ? '' : '　')}</td>
    //         </tr>
    //       </table></td></tr>

    //     </table>
    // `;

    return resHtml;
  }

  createHTMLBlockCombine(items: HistPrintOperationDataItemDto[], side?: 'Left' | 'Right') {
    return this.buildCombineUnits(items, side).map(u => (u as { html: string }).html).join('');
  }

  /** 療程合併醫令，一個就診日一個不可拆單元。 */
  buildCombineUnits(items: HistPrintOperationDataItemDto[], side?: 'Left' | 'Right'): PageUnit[] {
    if (!items) return [];

    //從items取得所有distinct historyid
    let historyIds = items.map(i => i.HistoryId).filter((value, index, self) => self.indexOf(value) === index);
    return historyIds.map(h => {
      let itemsByHistory = items.filter(i => i.HistoryId === h);
      let regDate = itemsByHistory[0].Date ? DateHelper.getROCFullDateString(new Date(itemsByHistory[0].Date), '/') : '';
      return {
        kind: 'fixed' as const,
        html: `
        <table style="width:100%; font-size: 12pt;">
          <tr><td><table style="width:100%; font-size: 12pt;">
            <tr>
              <td style="text-align: left; ${this.commonStyle}" ${this.commonClass}>日期:${regDate}</td>
            </tr>
          </table></td></tr>
        </table>
        <table style="width:100%; font-size: 12pt;">
        ${this.createHTMLBlockItem(itemsByHistory, side)}
        </table>
        `
      };
    });
  }

  createHTMLSummary(summary: number, records: number) {
    return '';

    var html = `<tr>
                    <td colspan='3' style="text-align: right; width: 33%; font-size: 14px; font-weight: bolder; border-right: 0px solid black; border-left: 0px solid black; border-top: 1px solid black; border-bottom: 1px solid black;">
                        小計:
                    </td>
                    <td style="text-align: right; width: 17%; font-size: 14px; font-weight: bolder; border-right: 0px solid black; border-left: 0px solid black; border-top: 1px solid black; border-bottom: 1px solid black;">
                        ` + (Math.round(summary*100)/100).toFixed(2) + `
                    </td>
                    <td style="text-align: left; width: 12%; font-size: 14px; font-weight: bolder; border-right: 0px solid black; border-left: 0px solid black; border-top: 1px solid black; border-bottom: 1px solid black;">

                    </td>
                    <td colspan='2' style="text-align: right; width: 18%; font-size: 14px; font-weight: bolder; border-right: 0px solid black; border-left: 0px solid black; border-top: 1px solid black; border-bottom: 1px solid black;">
                        筆數:
                    </td>
                    <td style="text-align: right; width: 18%; font-size: 14px; font-weight: bolder; border-right: 0px solid black; border-left: 0px solid black; border-top: 1px solid black; border-bottom: 1px solid black;">
                        ` + records + `筆
                    </td>
                    <td style="text-align: left; width: 2%; font-size: 14px; font-weight: bolder; border-right: 0px solid black; border-left: 0px solid black; border-top: 1px solid black; border-bottom: 1px solid black;">

                    </td>
                </tr>`;
    return html;
  }

  createHTMLFinish() {
      // return `<div style="-webkit-text-size-adjust: none; font-size: 12pt;zoom: 0.8;margin: 0px 10px; text-align: center; border-top: none;">
      //             <label style="font-weight: bold;">以下空白</label>
      //         </div>`;
      return '';
  }

  /**
   * 送印樣式全文，依目前的 pageSize 產生。
   *
   * 兩個消費端：fillData() 掛進畫面供預覽，getHtml() 前置到送印字串。
   * getHtml() 不得改為依賴畫面上的樣式節點－送印字串只含 reportContainer 的 innerHTML，
   * 而樣式節點是在 fillData() 之後的下一輪事件迴圈才掛上，同步呼叫 getHtml() 時尚不存在。
   */
  buildPrintStyleText() {
    return '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
      '.pres-report2 table{ border:0px solid black; border-collapse: collapse; }\n' +
      '.pres-report2 table td, table th { border-bottom: 0px solid black; padding-left: 0px;padding-right: 0px;}\n' +//調整左右padding 5px->0px
      '.pres-report2 table tr:first-child th { border-top: 0; vertical-align: bottom; padding: 0px }\n' +
      '.pres-report2 table tr:last-child td { border-bottom: 0; }\n' +
      '.pres-report2 table tr td:first-child, table tr th:first-child { border-left: 0; }\n' +
      '.pres-report2 table tr td:last-child, table tr th:last-child { border-right: 0; }\n' +
      '.pres-report2 table tr { line-height: 20px; }\n' +//調整每行高度
      // 一個 .page 對應一張實體紙。列印引擎不認得 class 名稱，唯有本規則能把
      // createHTMLPage() 切出的每個 .page 對齊到紙張邊界；缺少時只依內容高度自行切紙，
      // 滿版頁的尾段會與次頁內容印在同一張紙上。
      '.page { page-break-after: always; break-after: page; }\n' +
      '.page:last-child { page-break-after: auto; break-after: auto; }\n' +
      '@page { size: ' + this.pageSize + '; margin: 0.5cm 0.5cm; }\n';
  }

  getHtml() {
    var html = this.reportContainer.nativeElement.innerHTML;
    for (var i = 0; i <= this.upperboundIndex; i++) {
      //去除邊框, 實際印出到pdf
      html = html.replace('box-shadow: 0 0 0.15cm rgba(0, 0, 0, 0.15);','');
      html = html.replace('box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0.15cm;','');
      html = html.replace('box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);','');
      html = html.replace('box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 0.5cm;','');
    }
    return '<style>' + this.buildPrintStyleText() + '</style>' + html;
  }

  async onPrint() {
      const printContents = this.getHtml();
      for (let i = 1; i <= this.numberOfCopies; i++) {
        var ret = await this.localPrintService.printHtml(this.historyReport, this.shortReportName, printContents);
        if (!ret.Successed) break;
      }
      if (ret.Successed) {
          this.notification.showSuccess(this.shortReportName + '已送出列印!', true);
      } else {
          this.notification.showError(this.shortReportName + '送出列印失敗!');
      }
      this.printed.emit(true);
  }

  async exportAsExcel() {
    if (this.reportData.length > 0) {
      const table = this.reportContainer.nativeElement;

      //html已有<table>經由ExportTableToExcel()後最外層會加上<table>，導致Excel第一行會空白，所以轉出時把table轉div。
      const html = this.forExcel ? table.innerHTML.replace('table', 'div') : table.innerHTML;

      await this.hcrService.ExportTableToExcel(this.shortReportName, html);
    } else {
      this.notification.showInfo('查無資料可供匯出!');
    }

    this.forExcel = false;

    this.printed.emit(true);
  }

  stringFactory(src: string,maxlength :number): string {
    if (src == null || src == '' || src == undefined) return ''      // 使用正規表達式匹配中文字符
      const chineseCharacters = src.match(/[\u4e00-\u9fa5]/g);
      const fullWidthPattern = /[\uFF01-\uFF60\uFFE0-\uFFE6]/g;

      let initlength = 0;
      // 如果沒有中文字符，則返回整個字串的長度
      for (let ind = 0;ind <src.length; ind++) {
        let chineseAlpha = src[ind].match(/[\u4e00-\u9fa5]/g);
        let fullWidthAlpha = src[ind].match(/[\uFF01-\uFF60\uFFE0-\uFFE6]/g);
        if (chineseAlpha) initlength +=2;
        else if (fullWidthAlpha) initlength +=2;
        else initlength +=1;
        if (initlength > maxlength){
          return src.substr(0, ind);
        }
      }
    return src;
  }

}
